import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { EKey } from '../repositories/newbuilding-promos/entities/sort_variant/SortVariantSchema';
import { ESortVariants } from '../types/jsonQuery/sortType';
import { ISortVariant } from '../types/sortVariant';

const SORT_VARIANTS_MAP = new Map([
  [EKey.NewFirst, ESortVariants.NewFirst],
  [EKey.Popularity, ESortVariants.Popularity],
  [EKey.AboutToEnd, ESortVariants.AboutToEnd],
]);

export const mapSortVariants = (promosResponse: ISearchPromosV2ResponseSchema): ISortVariant[] => {
  return promosResponse.sortVariants.map(item => ({
    key: SORT_VARIANTS_MAP.get(item.key) as ESortVariants,
    value: item.value,
  }));
};
